import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment';

import { useAuth } from '../../context/AuthContext';
import { useBrandContext } from '../../context/BrandContext';

import api from '../../axios/axiosConfig';
import {
  ChargerStatusResponse,
  FileResponse,
} from '../viewers/valet/charger-status/types';
import { HeaderViewer } from '../../components/header-viewer/HeaderViewer';
import SwipeToRefresh from '../../components/SwipeToRefresh/SwipeToRefresh';

import calenderIcon from '../../assets/calender-icon.png';
import plug from '../../assets/plug.png';
import checkIcon from '../../assets/check_circle_valet.svg';
import checkIconAddCar from '../../assets/check-cicle-valet-full-bg.svg';

import Modal from '../../components/modal/Modal';
import { ConnectorStatus } from '../../constants/ConnectorStatus';
import { formatKw } from '../../utils/format';
import { FleetNotFoundComponent } from '../viewers/page/components/FleetNotFound';

import prismaIco from '../../assets/checklist.svg';
import carIco from '../../assets/car.svg';
import powerIco from '../../assets/power-fill.svg';
import trashIco from '../../assets/trash.svg';
import deleteIco from '../../assets/delete_outline_valet.svg';
import addCarIco from '../../assets/car-valet.svg';
import energyIco from '../../assets/energy-icon.svg';
import searchIco from '../../assets/search.svg';
import searchTableIco from '../../assets/search-table.svg';
import thunderIco from '../../assets/thunder.svg';

import { Footer } from '../viewers/valet/charger-status/components/Footer/Footer';
import './Valet.css';

enum QueueItemStatus {
  QUEUED = 'QUEUED',
  CHARGING = 'CHARGING',
  FINISHED = 'FINISHED',
}

const dic = {
  ['QUEUED']: 'Aguardando',
  ['CHARGING']: 'Carregando',
  ['FINISHED']: 'Finalizado',
};

interface QueueItem {
  cqId: string;
  cqCsId: string;
  cqUvLicencePlate: string;
  cqAnuId: null;
  cqUvId: null;
  cqTransactionUuid: null;
  cqCreatedAt: string;
  cqChargerId: string;
  cqUpdatedAt: string;
  chargePointId: string;
  connectorId: string;
  startTime: string;
  chargeStopTime: string;
  stopTime: string;
  meterTotal: number;
  duration: string;
  status: QueueItemStatus;
  cqCustomId: string;
  cqQueuedAt: string | null;
  chargePointName: string | null;
}

export const Valet = () => {
  const { id } = useParams();
  const authContext = useAuth();
  const brandContext = useBrandContext();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [availableConnectors, setAvailableConnectors] = useState<
    ChargerStatusResponse['connectors']
  >([]);
  const [connectorStatus, setConnectorStatus] =
    useState<ChargerStatusResponse>();
  const [background, setBackground] = useState<string>('');
  const [logo, setLogo] = useState<string>('');

  const [selectedQueueItem, setSelectedQueueItem] = useState<QueueItem | null>(
    null
  );
  const [placa, setPlaca] = useState('');
  const [prisma, setPrisma] = useState('');
  const [queueItems, setQueueItems] = useState<QueueItem[]>([]);
  const [errorsValidate, setErrorsValidate] = useState<{ placa?: string }>({});
  const [isActionLoading, setIsActionLoading] = useState<boolean>(false);
  const [isConnectorsLoading, setIsConnectorsLoading] =
    useState<boolean>(false);
  const [titleDialogModal, setTitleDialogModal] = useState<string>('');
  const [textDialogModal, setTextDialogModal] = useState<string>('');
  const [showDialogModal, setShowDialogModal] = useState<boolean>(false);
  const [isModalAddOpen, setIsModalAddOpen] = useState<boolean>(false);
  const [isModalStartOpen, setIsModalStartOpen] = useState<boolean>(false);
  const [isModalStatusOpen, setIsModalStatusOpen] = useState<boolean>(false);
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState<boolean>(false);
  const [selectedConnector, setSelectedConnector] = useState<any>(null);
  const [currentDate, setCurrentDate] = useState(
    moment().format('DD/MM/YYYY - HH:mm')
  );
  const [csId, setCsId] = useState<string>();
  const csIdRef = useRef<string>();
  const intervalValetQueueTimerRef = useRef<NodeJS.Timeout | number>();
  const availableConnectorsTimerRef = useRef<NodeJS.Timeout | number>();

  const [isDenied, setIsDenied] = useState<boolean>(false);

  const getConnectorsStatusBySite = async () => {
    try {
      const response = await api.get<ChargerStatusResponse>(
        `/viewer/SiteConnectorsStatus/${String(id)}`
      );
      if (response.data) {
        const connectors: ChargerStatusResponse['connectors'] = [];
        response.data.connectors.map((connector: any) => {
          if (
            connector.isConnected &&
            (connector.connectorStatus == ConnectorStatus.AVAILABLE ||
              connector.connectorStatus == ConnectorStatus.PREPARING)
          ) {
            connectors.push(connector);
          }
        });
        setConnectorStatus(response.data);
        setAvailableConnectors(connectors);
        setCsId(response.data.csId);
      }
    } catch (err: any) {
      if (err.response.status === 403) {
        setIsDenied(true);
        clearInterval(intervalValetQueueTimerRef.current);
      } else {
        setTitleDialogModal('Erro');
        setTextDialogModal('Ocorreu um erro de comunicação com o servidor.');
        setShowDialogModal(true);
      }
      console.error(err);
    } finally {
      return;
    }
  };

  const getFile = async (fileId: string) => {
    try {
      const response = await api.get<FileResponse>(`/Files/${String(fileId)}`);
      if (response.data) {
        setLogo(response.data.fileData);
      }
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  const getFileBg = async (fileId: string) => {
    try {
      const response = await api.get<FileResponse>(`/Files/${String(fileId)}`);
      if (response.data) {
        setBackground(response.data.fileData);
      }
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  const handlePlateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const originalValue = e.target.value
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '');

    let formattedValue = '';

    const isOldPlateFormat = /^[A-Z]{3}[0-9]{4}$/.test(originalValue);

    if (originalValue.length <= 3) {
      formattedValue = originalValue;
    } else if (isOldPlateFormat) {
      formattedValue = `${originalValue.slice(0, 3)}-${originalValue.slice(3)}`;
    } else {
      formattedValue = originalValue;
    }

    setPlaca(formattedValue);

    const isValidPlate = validatePlate(formattedValue);
    setErrorsValidate((prevErrors) => ({
      ...prevErrors,
      placa: isValidPlate ? undefined : 'Placa inválida',
    }));
  };

  const validatePlate = (plate: string) => {
    const oldPlatePattern = /^[A-Z]{3}-[0-9]{4}$/;
    const mercosulPlatePattern = /^[A-Z]{3}[0-9][A-Z][0-9]{2}$/;
    const normalizedPlate = plate.replace(/-/g, '');
    return (
      oldPlatePattern.test(plate) || mercosulPlatePattern.test(normalizedPlate)
    );
  };

  const getValetQueue = async () => {
    try {
      const response = await api.get<QueueItem[]>(
        `/valet/ValetQueue/${csIdRef.current}`,
        {
          headers: {
            Authorization: `Bearer ${authContext.token}`,
          },
        }
      );
      if (response.data) {
        setQueueItems(response.data);
      }
    } catch (err: any) {
      if (err.response.status === 403) {
        setIsDenied(true);
        clearInterval(intervalValetQueueTimerRef.current);
      } else {
        setTitleDialogModal('Erro');
        setTextDialogModal('Ocorreu um erro de comunicação com o servidor.');
        setShowDialogModal(true);
      }
    } finally {
      setIsLoading(false);
      return;
    }
  };

  const processValetQueueItem = async (
    cqUvLicencePlate: string,
    cqCustomId: string,
    cqId?: string
  ) => {
    setIsActionLoading(true);
    const payload: {
      cqCsId: string;
      cqUvLicencePlate: string;
      cqCustomId: string;
      cqId?: string;
    } = {
      cqCsId: String(csIdRef.current),
      cqUvLicencePlate,
      cqCustomId,
    };
    if (cqId) {
      payload['cqId'] = cqId;
    }
    try {
      const response = await api[cqId ? 'delete' : 'post'](
        `/valet/ValetQueue/${cqId ?? String(csIdRef.current)}`,
        payload
      );
      if (response.status >= 200 && response.status < 300) {
        setTitleDialogModal('Sucesso');
        setTextDialogModal(
          `Veículo ${cqUvLicencePlate} ${
            cqId ? 'removido da' : 'adicionado à'
          } fila.`
        );
        setShowDialogModal(true);
      } else {
        setTitleDialogModal('Erro');
        setTextDialogModal(
          `Houve um problema ao ${
            cqId ? 'remover' : 'adicionar'
          } o veículo ${cqUvLicencePlate}.`
        );
        setShowDialogModal(true);
      }
      await getValetQueue();
      setIsModalDeleteOpen(false);
      setIsActionLoading(false);
    } catch (err: any) {
      if (err.response.status === 409) {
        setTitleDialogModal('Erro');
        setTextDialogModal('Placa já adicionada.');
        setShowDialogModal(true);
        clearInterval(intervalValetQueueTimerRef.current);
      } else {
        console.error(err);
        setTitleDialogModal('Erro');
        setTextDialogModal('Ocorreu um erro de comunicação com o servidor.');
        setShowDialogModal(true);
      }
    } finally {
      return;
    }
  };

  const addQueueItem = async () => {
    if (isActionLoading) return;
    if (errorsValidate.placa) {
      alert('Por favor, insira uma placa válida');
      return;
    }

    await processValetQueueItem(placa, prisma);

    setIsModalAddOpen(false);
  };

  const startTransaction = async () => {
    if (!selectedQueueItem || isActionLoading) return;
    setIsActionLoading(true);
    const payload = {
      cqId: selectedQueueItem?.cqId,
      chargePointId: selectedConnector?.chargePointId,
      connectorId: selectedConnector?.connectorId,
    };
    try {
      const response = await api.post<any>(
        `/valet/ValetRemoteStartTransaction/${selectedQueueItem?.cqId}`,
        payload
      );
      if (response.data.status === 'Accepted') {
        setTitleDialogModal('Ação necessária');
        setTextDialogModal(
          `Plugue o veículo ${selectedQueueItem?.cqUvLicencePlate} para iniciar a recarga.`
        );
        setShowDialogModal(true);
        setIsModalStartOpen(false);
      } else if (
        response.data.status === 'Rejected' &&
        response.data.info === 'ERR_WALLET_LOW_BALANCE'
      ) {
        setTitleDialogModal('Erro');
        setTextDialogModal('O usuário não tem créditos suficiente.');
        setShowDialogModal(true);
      } else if (response.data.status === 'TimedOut') {
        setTitleDialogModal('Erro');
        setTextDialogModal('O tempo de conexão do veículo expirou.');
        setShowDialogModal(true);
      } else {
        setTitleDialogModal('Erro');
        setTextDialogModal('Ocorreu um erro de comunicação com o servidor.');
        setShowDialogModal(true);
      }
    } catch (err) {
      console.error(err);
      setTitleDialogModal('Erro');
      setTextDialogModal('Ocorreu um erro de comunicação com o servidor.');
      setShowDialogModal(true);
    } finally {
      setIsActionLoading(false);
      return;
    }
  };

  // const finishTransaction = () => {
  //   // remover o botão por enquanto
  //   if (!selectedQueueItem || isActionLoading) return;

  //   // closeModal();
  // };

  const removeQueueItem = (
    cqUvLicencePlate: string,
    cqCustomId: string,
    cqId: string
  ) => {
    if (isActionLoading) return;

    setSelectedQueueItem({
      ...selectedQueueItem,
      cqUvLicencePlate,
      cqCustomId,
      cqId,
    } as QueueItem);

    setIsModalDeleteOpen(true);
  };

  useEffect(() => {
    if (background && logo) return;
    if (connectorStatus?.csLogoFileId) {
      getFile(connectorStatus.csLogoFileId);
    }
    if (connectorStatus?.csBgFileId) {
      getFileBg(connectorStatus.csBgFileId);
    }
  }, [connectorStatus]);

  const formatTime = (startTime: string) => {
    const elapsed = Math.floor(
      (Date.now() - new Date(startTime).getTime()) / 1000
    );
    const hours = String(Math.floor(elapsed / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((elapsed % 3600) / 60)).padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  useEffect(() => {
    if (!csId) return;
    csIdRef.current = csId;
    getValetQueue();
  }, [csId]);

  useEffect(() => {
    if (!isModalAddOpen) {
      setPlaca('');
      setPrisma('');
      setErrorsValidate({});
    }
  }, [isModalAddOpen]);

  useEffect(() => {
    if (!isModalStartOpen) {
      setSelectedQueueItem(null);
      setSelectedConnector(null);
      clearInterval(availableConnectorsTimerRef.current);
    } else {
      availableConnectorsTimerRef.current = setInterval(
        getConnectorsStatusBySite,
        5 * 1000
      );
    }
  }, [isModalStartOpen]);

  useEffect(() => {
    let queueInterval: NodeJS.Timeout | null = null;
    let dateInterval: NodeJS.Timeout | null = null;
    let isVisible = !document.hidden;

    const startPolling = async () => {
      if (isDenied) return;
      
      if (queueInterval) clearInterval(queueInterval);
      if (dateInterval) clearInterval(dateInterval);
      
      await getConnectorsStatusBySite();
      queueInterval = setInterval(getValetQueue, 15 * 1000);
      intervalValetQueueTimerRef.current = queueInterval;
      
      dateInterval = setInterval(() => {
        setCurrentDate(moment().format('DD/MM/YYYY - HH:mm'));
      }, 60 * 1000);
    };

    const stopPolling = () => {
      if (queueInterval) {
        clearInterval(queueInterval);
        queueInterval = null;
      }
      if (dateInterval) {
        clearInterval(dateInterval);
        dateInterval = null;
      }
    };

    const handleVisibilityChange = () => {
      isVisible = !document.hidden;
      if (isVisible) {
        console.log('Página visível - retomando polling (valet)');
        startPolling();
      } else {
        console.log('Página oculta - pausando polling (valet)');
        stopPolling();
      }
    };

    // Inicia polling se página está visível
    if (isVisible && !isDenied) {
      startPolling();
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      stopPolling();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isDenied]);

  interface Style {
    modalContainer: React.CSSProperties;
    modalText: React.CSSProperties;
    modalInputLabel: React.CSSProperties;
  }

  const style: Style = {
    modalContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
      flexWrap: 'wrap',
      height: '100%',
      width: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      // padding: '16px',
    },
    modalText: {
      fontWeight: 'normal',
      fontSize: '1.4rem',
      marginTop: 20,
      marginBottom: 20,
    },
    modalInputLabel: {
      fontWeight: 'normal',
      fontSize: 16,
      marginTop: 20,
      marginBottom: 10,
    },
  };

  if (isLoading && !isDenied) {
    return (
      <div className='cs-carregando'>
        <span>Carregando...</span>
      </div>
    );
  }

  if (isDenied) {
    return (
      <FleetNotFoundComponent
        messageError='Falha ao Carregar Dados'
        title={`Não foi possível buscar as informações para o ID  "${id}".`}
        subtitle='Verifique se o ID está correto ou se a requisição está falhando.'
      />
    );
  }

  return (
    <>
      <div className='container-fluid valet' style={{ padding: '0 16px' }}>
        <HeaderViewer
          logo={logo}
          background={background}
          bgColor={connectorStatus?.csBgColor}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div className='cs-wrapper-date'>
            <img
              src={calenderIcon}
              alt={`${calenderIcon}`}
              className='cs-calender-icon'
            />
            <span>{currentDate}</span>
          </div>
          <a
            href={`/viewers/vallet/charger-status/${String(id)}`}
            style={{ textDecoration: 'none', marginTop: '16px' }}
          >
            <button className='go-to-chargers-button'>Carregadores</button>
          </a>
        </div>
        <div className='cs-header-charger-status'>
          <img src={plug} alt={`${plug}`} className='cs-plug-image' />
          <p className='cs-local-title'>{connectorStatus?.csName}</p>
        </div>

        <button
          type='button'
          className='new'
          onClick={() => setIsModalAddOpen(true)}
        >
          <span className='btn-add-car'>Adicionar veículo </span>
          <img
            src={checkIconAddCar}
            alt={`${checkIconAddCar}`}
            className='cs-table-icon'
          />
        </button>

        <SwipeToRefresh
          onSwipeDown={() => {
            getValetQueue();
            getConnectorsStatusBySite();
          }}
        >
          <div className='cs-chargers-wrapper'>
            <div className='cs-chargers-header'>
              <span className='cs-chargers-header-title'>Valet</span>
            </div>
            <div className='cs-gradient' />
            <div className='cs-table-container'>
              <table className='cs-table'>
                <thead className='cs-table-head'>
                  <tr className='cs-table-head-tr'>
                    <th
                      style={{ paddingLeft: 10 }}
                      className='cs-table-head-th cs-table-head-th-prisma'
                    >
                      <div className='cs-th-single-duration'>
                        <img
                          src={prismaIco}
                          alt={`${prismaIco}`}
                          className='cs-table-icon'
                        />
                        <span className='hidden-header'>Prisma</span>
                      </div>
                    </th>
                    <th
                      style={{ paddingLeft: 10 }}
                      className='cs-table-head-th cs-table-head-th-license'
                    >
                      <div className='cs-th-single-duration'>
                        <img
                          src={carIco}
                          alt={`${carIco}`}
                          className='cs-table-icon'
                        />
                        <span className='hidden-header'>Veículo</span>
                      </div>
                    </th>
                    <th className='cs-table-head-th cs-table-head-th-charger'>
                      <div className='cs-th-single-duration'>
                        <img
                          src={powerIco}
                          alt={`${powerIco}`}
                          className='cs-table-icon'
                        />
                        <span className='hidden-header'>Carregador</span>
                      </div>
                    </th>
                    <th className='cs-table-head-th cs-table-head-th-status'>
                      <div className='cs-th-single-status'>
                        <img
                          src={checkIcon}
                          alt={`${checkIcon}`}
                          className='cs-table-icon'
                        />
                        <span>Status</span>
                      </div>
                    </th>
                    <th className='cs-table-head-th cs-table-head-th-btns'></th>
                  </tr>
                </thead>
                <tbody className='cs-table-body'>
                  {queueItems.map((queueItem: QueueItem) => (
                    <tr key={queueItem.cqId}>
                      {/* <tr className='cs-charger-info-tr' key={queueItem.cqId}> */}
                      {/* Prisma */}
                      <td>
                        <div className='cs-charger-info'>
                          <input
                            className='number'
                            type='text'
                            value={queueItem.cqCustomId}
                            disabled
                          />
                        </div>
                      </td>
                      {/* Prisma */}

                      {/* Placa */}
                      <td style={{ paddingLeft: 10 }}>
                        <div>
                          <input
                            className='license'
                            type='text'
                            value={queueItem.cqUvLicencePlate}
                            readOnly
                          />
                        </div>
                      </td>
                      {/* Placa */}

                      {/* Energia */}
                      <td style={{ paddingRight: 10 }}>
                        <div>
                          {queueItem.status === QueueItemStatus.CHARGING && (
                            <>
                              <div style={{ whiteSpace: 'nowrap' }}>
                                <span className='charger-name'>
                                  {queueItem.chargePointName} -{' '}
                                  {queueItem.connectorId}
                                </span>
                              </div>
                              <div>
                                <span
                                  className='charger-kwh'
                                  style={{ whiteSpace: 'nowrap' }}
                                >
                                  {`${
                                    queueItem.meterTotal !== 0
                                      ? formatKw(queueItem.meterTotal)
                                      : '0.0'
                                  } kWh`}
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                      </td>
                      {/* Energia */}

                      {/* Status */}
                      <td>
                        <div
                          style={{
                            paddingTop: 10,
                            paddingRight: 2,
                            paddingBottom: 10,
                          }}
                        >
                          <div
                            className={`cs-chager-status-wrapper status ${
                              !queueItem.cqQueuedAt
                                ? 'btn-secondary'
                                : queueItem.status === QueueItemStatus.CHARGING
                                ? 'btn-charging'
                                : queueItem.status === QueueItemStatus.FINISHED
                                ? 'btn-finished'
                                : 'btn-waiting'
                            }`}
                          >
                            {' '}
                            {queueItem.cqQueuedAt ? (
                              <>
                                {' '}
                                {dic[queueItem.status]}
                                {queueItem.status ===
                                  QueueItemStatus.CHARGING &&
                                  queueItem.startTime && (
                                    <span>{` ${formatTime(
                                      queueItem.startTime
                                    )}`}</span>
                                  )}
                                {queueItem.status ===
                                  QueueItemStatus.FINISHED &&
                                  queueItem.duration && (
                                    <span>{` ${queueItem.duration.slice(
                                      0,
                                      -3
                                    )}`}</span>
                                  )}
                              </>
                            ) : (
                              'Pendente'
                            )}
                          </div>
                        </div>
                      </td>
                      {/* Status */}
                      {/* Botões de ação */}
                      <td>
                        {/* <div style={{ display: 'flex' }}> */}
                        {queueItem.cqQueuedAt ? (
                          <>
                            {queueItem.status === QueueItemStatus.QUEUED && (
                              <div
                                style={{
                                  display: 'flex',
                                  gap: 8,
                                }}
                                className='action-row-link'
                              >
                                <div>
                                  <button
                                    type='button'
                                    className='btn btn-queued'
                                    onClick={async () => {
                                      setSelectedQueueItem(queueItem);
                                      setIsModalStartOpen(true);
                                      setIsConnectorsLoading(true);
                                      await getConnectorsStatusBySite();
                                      setIsConnectorsLoading(false);
                                    }}
                                  >
                                    <img src={thunderIco} alt='' />
                                  </button>
                                </div>
                                <div>
                                  <button
                                    type='button'
                                    className='btn btn-queued'
                                    onClick={() => {
                                      removeQueueItem(
                                        queueItem.cqUvLicencePlate,
                                        queueItem.cqCustomId,
                                        queueItem.cqId
                                      );
                                    }}
                                  >
                                    <img src={trashIco} alt='' />
                                  </button>
                                </div>
                              </div>
                            )}
                            {queueItem.status === QueueItemStatus.CHARGING && (
                              <div style={{ display: 'flex', padding: 0 }}>
                                <button
                                  type='button'
                                  className='btn btn-status-icon'
                                  onClick={async () => {
                                    setSelectedQueueItem(queueItem);
                                    setIsModalStatusOpen(true);
                                  }}
                                >
                                  <img src={searchTableIco} alt='' />
                                </button>
                              </div>
                            )}
                          </>
                        ) : (
                          <div style={{ padding: 0 }}>
                            <button
                              type='button'
                              className='btn btn-status-icon'
                              onClick={() => {
                                removeQueueItem(
                                  queueItem.cqUvLicencePlate,
                                  queueItem.cqCustomId,
                                  queueItem.cqId
                                );
                              }}
                            >
                              <img src={trashIco} alt='' />
                            </button>
                          </div>
                        )}
                        {/* </div> */}
                        {/* <div
                        className={`col-${
                          !queueItem.cqQueuedAt
                            ? 10
                            : queueItem.status === QueueItemStatus.QUEUED
                            ? 8
                            : queueItem.status === QueueItemStatus.CHARGING
                            ? 10
                            : 12
                        }`}
                      ></div> */}
                      </td>
                      {/* Botões de ação */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </SwipeToRefresh>
      </div>
      <Footer />
      {/* Adicionar novo veiculo */}
      <div
        style={{
          ...style.modalContainer,
          display: isModalAddOpen ? 'flex' : 'none',
        }}
      >
        <Modal
          isOpen={isModalAddOpen}
          onClose={() => setIsModalAddOpen(false)}
          textEnterButton='Adicionar'
          handleEnterButton={addQueueItem}
          isLoadingEnterButton={isActionLoading}
          styleEnterButton={{
            backgroundColor: '#3CCC10',
            color: '#003844',
          }}
          allowButtonClosed={true}
          disableEnterButton={!!errorsValidate.placa || !placa || !prisma}
        >
          <div className='toast-start-charging-content'>
            <div className='toast-start-charging-title' style={style.modalText}>
              <img src={addCarIco} alt='' className='icon-title-modal' />
              Adicionar veículo
            </div>

            <div
              className='toast-start-charging-title label-modal-input'
              style={style.modalInputLabel}
            >
              Placa do veículo
            </div>
            <input
              type='text'
              className={`input-spt ${
                errorsValidate.placa ? 'input-license-error-modal' : ''
              }`}
              value={placa}
              onChange={handlePlateChange}
            />
            {errorsValidate.placa && (
              <div className='error-license-msg'>{errorsValidate.placa}</div>
            )}
            <div
              className='toast-start-charging-title label-modal-input'
              style={style.modalInputLabel}
            >
              Número do prisma
            </div>
            <input
              type='text'
              className='input-spt'
              value={prisma}
              onChange={(e) => setPrisma(e.target.value)}
            />
          </div>
        </Modal>
      </div>
      {/* Adicionar novo veiculo */}

      {/* Iniciar recargar */}
      <div
        style={{
          ...style.modalContainer,
          display: isModalStartOpen ? 'flex' : 'none',
        }}
      >
        <Modal
          isOpen={isModalStartOpen}
          onClose={() => setIsModalStartOpen(false)}
          textEnterButton='Iniciar'
          disableEnterButton={!selectedConnector || isConnectorsLoading}
          handleEnterButton={startTransaction}
          isLoadingEnterButton={isActionLoading}
          styleEnterButton={{
            backgroundColor: '#3CCC10',
            color: '#003844',
          }}
          allowButtonClosed={true}
        >
          <div className='toast-start-charging-content'>
            <div className='toast-start-charging-title' style={style.modalText}>
              <img src={energyIco} alt='' className='icon-title-modal' />
              Iniciar a recarga
            </div>
            <div
              className='toast-start-charging-title label-modal-input'
              style={style.modalInputLabel}
            >
              Placa do veículo
            </div>
            <div className='readyOnly-label'>
              {selectedQueueItem?.cqUvLicencePlate}
            </div>
            <div
              className='toast-start-charging-title label-modal-input'
              style={style.modalInputLabel}
            >
              Prisma
            </div>
            <div className='readyOnly-label'>
              {selectedQueueItem?.cqCustomId}
            </div>
            <div className='line-height-spacer'></div>
            <div className='label-modal-input'>Selecione um carregador:</div>
            <div className='line-height-spacer'></div>
            <div className=' ' style={{ marginBottom: 30 }}>
              {isConnectorsLoading ? (
                <div style={{ textAlign: 'center', lineHeight: '50px' }}>
                  Carregando...
                </div>
              ) : availableConnectors && availableConnectors.length > 0 ? (
                <tr className='chargers-container-grid'>
                  {availableConnectors.map((connector, index) => {
                    return (
                      <td
                        key={index}
                        onClick={() => setSelectedConnector(connector)}
                      >
                        <button
                          type='button'
                          className={`btn ${
                            selectedConnector?.chargePointId ===
                            connector.chargePointId
                              ? 'recharge-active'
                              : 'recharge'
                          } `}
                          style={{
                            border: `1px solid ${
                              connector.connectorStatus ===
                              ConnectorStatus.AVAILABLE
                                ? '#7f8784'
                                : connector.connectorStatus ===
                                  ConnectorStatus.PREPARING
                                ? '#CEDCE9'
                                : ''
                            }`,
                            backgroundColor:
                              connector.connectorStatus ===
                              ConnectorStatus.AVAILABLE
                                ? '#E5E8EB'
                                : connector.connectorStatus ===
                                  ConnectorStatus.PREPARING
                                ? '#CEDCE9'
                                : '',
                            color:
                              connector.connectorStatus ===
                              ConnectorStatus.AVAILABLE
                                ? '#7f8784'
                                : connector.connectorStatus ===
                                  ConnectorStatus.PREPARING
                                ? '#2688E2'
                                : '',
                          }}
                          onClick={() => setSelectedConnector(connector)}
                        >
                          <div style={{ textWrap: 'nowrap' }}>
                            {`${connector.name} - ${connector.connectorId}`}
                          </div>
                        </button>
                      </td>
                    );
                  })}
                </tr>
              ) : (
                <div style={{ textAlign: 'center', lineHeight: '50px' }}>
                  Nenhum carregador disponível
                </div>
              )}
            </div>
          </div>
        </Modal>
      </div>
      {/* Iniciar recargar */}

      {/* Excluir veículo */}
      <div
        style={{
          ...style.modalContainer,
          display: isModalDeleteOpen ? 'flex' : 'none',
        }}
      >
        <Modal
          isOpen={isModalDeleteOpen}
          onClose={() => setIsModalDeleteOpen(false)}
          textEnterButton='Confirmar'
          handleEnterButton={() => {
            processValetQueueItem(
              selectedQueueItem?.cqUvLicencePlate as string,
              selectedQueueItem?.cqCustomId as string,
              selectedQueueItem?.cqId
            );
          }}
          isLoadingEnterButton={isActionLoading}
          styleEnterButton={{
            backgroundColor: '#3CCC10',
            color: '#003844',
          }}
          allowButtonClosed={true}
        >
          <div className='toast-start-charging-content'>
            <div className='toast-start-charging-title' style={style.modalText}>
              <img src={deleteIco} alt='' className='icon-title-modal' />
              Excluir veículo
            </div>
            <div className='toast-start-charging-text'>
              Deseja realmente excluir o veículo da lista?
            </div>
            <div className='line-height-spacer'></div>
            <div
              className='toast-start-charging-title label-modal-input'
              style={style.modalInputLabel}
            >
              Placa do veículo
            </div>

            <div className='readyOnly-label'>
              {selectedQueueItem?.cqUvLicencePlate}
            </div>
            <div className='line-height-spacer'></div>
            <div
              className='toast-start-charging-title label-modal-input'
              style={style.modalInputLabel}
            >
              Prisma
            </div>
            <div className='readyOnly-label'>
              {selectedQueueItem?.cqCustomId}
            </div>
            <div className='line-height-spacer'></div>
          </div>
        </Modal>
      </div>
      {/* Excluir veículo */}

      {/* Finalizar recarga */}
      <div
        style={{
          ...style.modalContainer,
          display: isModalStatusOpen ? 'flex' : 'none',
        }}
      >
        <Modal
          isOpen={isModalStatusOpen}
          onClose={() => setIsModalStatusOpen(false)}
          disableEnterButton={true}
          // textEnterButton='Confirmar'
          // handleEnterButton={() => {
          // }}
          // isLoadingEnterButton={isActionLoading}
          styleEnterButton={{
            backgroundColor: '#3CCC10',
            color: '#003844',
            padding: '11px',
            height: 'auto',
          }}
          allowButtonClosed={true}
        >
          <div className='toast-start-charging-content'>
            <div className='toast-start-charging-title' style={style.modalText}>
              <img src={searchIco} alt='' className='icon-title-modal' />
              Sobre a recarga
            </div>

            <div className='toast-start-charging-text'>
              Para finalizar a recarga, desplugue o veículo
            </div>
            <div className='line-height-spacer'></div>
            <div
              className='toast-start-charging-title label-modal-input'
              style={style.modalInputLabel}
            >
              Placa do veículo
            </div>

            <div className='readyOnly-label'>
              {selectedQueueItem?.cqUvLicencePlate}
            </div>
            <div className='line-height-spacer'></div>
            <div
              className='toast-start-charging-title label-modal-input'
              style={style.modalInputLabel}
            >
              Prisma
            </div>
            <div className='readyOnly-label'>
              {selectedQueueItem?.cqCustomId}
            </div>
          </div>
          <div className='line-height-spacer'></div>
        </Modal>
      </div>
      {/* Finalizar recarga */}

      <Modal
        allowButtonClosed={false}
        isOpen={showDialogModal}
        onClose={() => setShowDialogModal(false)}
        title={titleDialogModal}
        styleEnterButton={{
          backgroundColor: 'rgb(173, 173, 173)',
          border: 'none',
        }}
        textEnterButton='Fechar'
        handleEnterButton={() => setShowDialogModal(false)}
        isLoadingEnterButton={false}
      >
        <p>{textDialogModal}</p>
      </Modal>
    </>
  );
};
